import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Gifts, GiftsRequest, GiftsResponse } from './types'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}
export const giftsListMounted = createEvent<GiftsRequest>()

export const getGifts = fx<GiftsRequest, GiftsResponse>({
  method: 'GET',
  url: `/giftshop/gift`,
})

export const $gifts = restore<Gifts[]>(
  getGifts.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfGifts = restore(
  getGifts.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: giftsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy === 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'availableCountries'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    // @ts-ignore
    query['populate'] = JSON.stringify(['Gift.giftCategory'])

    return {
      query,
    }
  },
  target: getGifts,
})
